import { delayedAttrRemove } from "panel/build/component-utils/hook-helpers";
import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
import { ContextPanelEl } from "common/widgets/context-panel";
import { ButtonBarEl } from "common/components/button-bar";
import { MenuSearchBar } from "../mixins/search";
export function template() {
  if (!this.attr(`open`)) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".mp-multi-events-menu",
      class: { "mp-child-menu": true }
    });
  }
  const { isMenuLoading, keydownProxyEl, searchFilter, tooltipData } = this.state;
  const InnerSearch = MenuSearchBar({
    value: this.state.searchFilter,
    handleSearchInput: (searchFilter2) => this.update({ searchFilter: searchFilter2 }),
    onInsert: (el) => this.update({ keydownProxyEl: el })
  });
  return /* @__PURE__ */ jsx("div", {
    sel: "mp-multi-events-menu",
    class: { "mp-child-menu": true }
  }, InnerSearch, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      elref: `mainSelectionMenu`,
      "show-select-all": !isMenuLoading,
      "show-select-all-matching": !isMenuLoading,
      multiple: this.attr(`multiple`),
      "search-filter": searchFilter
    },
    on: {
      click: (ev) => ev.stopPropagation(),
      clickItem: this.helpers.handleItemClick,
      selectAll: this.helpers.handleSelectAll,
      selectAllMatching: this.helpers.handleSelectAllMatching,
      focusItem: (ev) => this.handleItemFocus(ev)
    },
    props: {
      keydownProxyEl,
      sections: this.helpers.getMenuSections()
    }
  }), this.attr(`open`) && tooltipData ? /* @__PURE__ */ jsx(ContextPanelEl, {
    hook: { remove: delayedAttrRemove(`tooltip-data`, null) },
    attrs: {
      "tooltip-data": tooltipData,
      "position-parent-selector": `mp-drop-menu`,
      elRef: `contextPanel`
    },
    on: {
      tooltipContextAction: this.helpers.propagateEvent,
      tooltipContextEditDescription: this.helpers.propagateEvent
    }
  }) : null, /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: ".mp-button-bar-primary",
    attrs: { disabled: !this.helpers.canCommit() },
    on: { click: this.helpers.onCommitClick }
  }, this.helpers.getCommitLabel()));
}
